module.exports = __webpack_public_path__ + "static/media/polytope_3_3_52_vertex_explode.8d1a4149.gif";